"use strict";

angular.module("informaApp")
    .service("DiseaseNameHelper", function () {
        return {
            breakWord: function (diseaseName) {
                return diseaseName.replace(/\//g, "/ ");
            }
        }
    });